import React, { useEffect, useState } from "react";
import { supabase } from "../../supabase-client";
import CotizacionModal from "../../components/modal/CotizacionModal";
import {
   Plus,
} from "lucide-react";
import { ESTADOS_COTIZACION  } from "../../utils/estados";
export default function Miscotizaciones() {
   const [cotizaciones, setCotizacions] = useState([]);
   const token = localStorage.getItem("authjwt");
   const [loading, setLoading] = useState(true);
   const [selectedCotizacion, setSelectedCotizacion] = useState(null); // 👈 Starts as null
   const [filterEstado, setFilterEstado] = useState("todos");
   // const [isModalOpen, setIsModalOpen] = useState(false); // 👈 Remove this, not needed
   if (token === null) {
      alert("Debe iniciar sesión para acceder a esta página asi podemos hacerle un seguimiento a sus cotizaciones");
      window.location.href = "/login";
   }
   // Estados disponibles
   const estados = ESTADOS_COTIZACION
   
   // Fetch cotizaciones from database
   const fetchCotizacions = async () => {
      setLoading(true);
      try {
         const { data: users, error: fetchError } = await supabase
            .from("usuarios")
            .select("*")
            .eq("password_hash", localStorage.getItem("authjwt")) // 👈 Use id instead of password_hash
            .single();

         if (fetchError) {
            console.error("Error fetching user:", fetchError);
            return;
         }

         if (!users) {
            console.error("No user found");
            return;
         }
         console.log('users.id: ', users.id);

         const { data, error } = await supabase
            .from("cotizacion")
            .select(
               `
               *,
               usuarios (
                  id,
                  nombre,
                  email,
                  documento,
                  celular
               ),
               cotizacion_pagos (
                  dolar,
                  pesos,
                  precio
               )
            `
            )
            .eq("usuario_id", users.id)
            .order("created_at", { ascending: false });

         if (error) {
            console.error("Error fetching cotizaciones:", error);
            alert("Error al cargar las cotizaciones");
            return;
         }

         setCotizacions(data || []);
         console.log("data: ", data);
      } catch (err) {
         console.error("Error:", err);
         alert("Error al conectar con la base de datos");
      }
      setLoading(false);
   };

   // Filter cotizaciones by estado
   const filteredCotizacions =
      filterEstado === "todos"
         ? cotizaciones
         : cotizaciones.filter((cotizacion) => cotizacion.estado === filterEstado);

   // Format date
   const formatDate = (dateString) => {
      return new Date(dateString).toLocaleString("es-AR", {
         year: "numeric",
         month: "2-digit",
         day: "2-digit",
         hour: "2-digit",
         minute: "2-digit",
      });
   };

   // 👈 Function to view existing cotizacion
   const verCotizacion = (cotizacion) => {
      setSelectedCotizacion(cotizacion);
   };

   // 👈 Function to create new cotizacion
   const nuevaCotizacion = () => {
      setSelectedCotizacion({
         id: 0, // 👈 id = 0 indicates new record
         titulo: "",
         detalle: "",
         usuario_id: 0,
         alto: 0,
         ancho: 0,
         profundidad: 0,
         precio: 0,
         porcentaje: 0,
         saldo: 0,
         estado: "Pendiente",
      });
   };

   // 👈 Function to close modal
   const cerrarModal = () => {
      setSelectedCotizacion(null);
      // Refresh data after modal closes
      fetchCotizacions();
   };

   useEffect(() => {
      fetchCotizacions();
   }, []);

   if (loading) {
      return (
         <div className="min-h-screen bg-[#FAFAF8] px-6 py-16 text-center">
            <p className="mb-4 text-[0.68rem] uppercase tracking-[0.24em] text-[#9B6D3F]">
               Cotizaciones
            </p>
            <h1
               className="text-4xl font-medium text-[#1A1A1A] md:text-5xl"
               style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
            >
               Cargando seguimiento
            </h1>
            <div className="mt-8 flex items-center justify-center gap-3 text-sm text-[#7A7570]">
               <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#9B6D3F] border-t-transparent"></div>
               <span>Cargando cotizaciones...</span>
            </div>
         </div>
      );
   }

   console.log("cotizaciones: ", cotizaciones);
   return (
      <div className="min-h-screen bg-[#FAFAF8] px-6 py-12 md:py-16">
         <div className="mx-auto max-w-7xl">
            <div className="mb-10 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
               <div>
                  <p className="mb-4 text-[0.68rem] uppercase tracking-[0.24em] text-[#9B6D3F]">
                     Seguimiento
                  </p>
                  <h1
                     className="text-4xl font-medium leading-[1.04] text-[#1A1A1A] md:text-6xl"
                     style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
                  >
                     Cotizaciones
                  </h1>
                  <p className="mt-4 max-w-2xl text-sm leading-relaxed text-[#7A7570]">
                     Revise el estado de cada proyecto, sus importes y el historial de solicitudes abiertas.
                  </p>
               </div>

               <button
                  onClick={nuevaCotizacion}
                  className="inline-flex items-center justify-center gap-2 bg-[#9B6D3F] px-5 py-3 text-[0.72rem] uppercase tracking-[0.16em] text-white transition-colors hover:bg-[#6B4A2A]"
               >
                  <Plus className="h-4 w-4" />
                  Nueva solicitud
               </button>
            </div>

            <div className="mb-8 flex flex-col gap-3 border border-[#EDE9E4] bg-white p-5 md:flex-row md:items-center md:justify-between">
               <div>
                  <p className="text-[0.68rem] uppercase tracking-[0.18em] text-[#7A7570]">
                     Filtrar por estado
                  </p>
               </div>
               <select
                  value={filterEstado}
                  onChange={(e) => setFilterEstado(e.target.value)}
                  className="w-full border border-[#EDE9E4] bg-[#FAFAF8] px-4 py-3 text-sm text-[#1A1A1A] outline-none transition-colors focus:border-[#9B6D3F] md:w-72"
               >
                  <option value="todos">Todos los estados</option>
                  {Object.entries(estados).map(([key, config]) => (
                     <option key={key} value={key}>
                        {config.label}
                     </option>
                  ))}
               </select>
            </div>

            {filteredCotizacions.length === 0 ? (
               <div className="border border-[#EDE9E4] bg-white px-6 py-16 text-center text-sm text-[#7A7570]">
                  {filterEstado === "todos"
                     ? "No hay cotizaciones registradas"
                     : `No hay cotizaciones con estado: ${estados[filterEstado]?.label}`}
               </div>
            ) : (
               <>
                  <div className="hidden overflow-hidden border border-[#EDE9E4] bg-white lg:block">
                     <table className="w-full">
                        <thead className="border-b border-[#EDE9E4] bg-[#FBF7F2]">
                           <tr>
                              <th className="px-6 py-4 text-left text-[0.68rem] font-medium uppercase tracking-[0.18em] text-[#7A7570]">
                                 ID
                              </th>
                              <th className="px-6 py-4 text-left text-[0.68rem] font-medium uppercase tracking-[0.18em] text-[#7A7570]">
                                 Fecha
                              </th>
                              <th className="px-6 py-4 text-left text-[0.68rem] font-medium uppercase tracking-[0.18em] text-[#7A7570]">
                                 Título
                              </th>
                              <th className="px-6 py-4 text-left text-[0.68rem] font-medium uppercase tracking-[0.18em] text-[#7A7570]">
                                 Precio
                              </th>
                              <th className="px-6 py-4 text-left text-[0.68rem] font-medium uppercase tracking-[0.18em] text-[#7A7570]">
                                 Estado
                              </th>
                           </tr>
                        </thead>
                        <tbody>
                           {filteredCotizacions.map((cotizacion) => {
                              const estadoConfig =
                                 estados[cotizacion.estado?.toLowerCase()] || estados.pendiente;
                              const IconComponent = estadoConfig.icon;

                              return (
                                 <tr
                                    key={cotizacion.id}
                                    onClick={() => verCotizacion(cotizacion)}
                                    className="cursor-pointer border-b border-[#F1ECE6] transition-colors hover:bg-[#FBF7F2]"
                                 >
                                    <td className="px-6 py-5 text-sm font-medium text-[#1A1A1A]">
                                       #{cotizacion.id}
                                    </td>
                                    <td className="px-6 py-5 text-sm text-[#7A7570]">
                                       {formatDate(cotizacion.created_at)}
                                    </td>
                                    <td className="px-6 py-5">
                                       <div className="text-sm font-medium text-[#1A1A1A]">
                                          {cotizacion.titulo || "N/A"}
                                       </div>
                                       {cotizacion.detalle ? (
                                          <div className="mt-1 max-w-md truncate text-sm text-[#7A7570]">
                                             {cotizacion.detalle}
                                          </div>
                                       ) : null}
                                    </td>
                                    <td className="px-6 py-5 text-sm font-medium text-[#9B6D3F]">
                                       {cotizacion.precio > 0 ? (
                                          `U$S ${Number(cotizacion.precio).toLocaleString()}`
                                       ) : (
                                          <span className="text-[#B3ADA7]">Pendiente</span>
                                       )}
                                    </td>
                                    <td className="px-6 py-5">
                                       <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium ${estadoConfig.color}`}>
                                          <IconComponent className="h-3.5 w-3.5" />
                                          {estadoConfig.label}
                                       </span>
                                    </td>
                                 </tr>
                              );
                           })}
                        </tbody>
                     </table>
                  </div>

                  <div className="space-y-4 lg:hidden">
                     {filteredCotizacions.map((cotizacion) => {
                        const estadoConfig =
                           estados[cotizacion.estado?.toLowerCase()] || estados.pendiente;
                        const IconComponent = estadoConfig.icon;

                        return (
                           <article
                              key={cotizacion.id}
                              onClick={() => verCotizacion(cotizacion)}
                              className="cursor-pointer border border-[#EDE9E4] bg-white p-5 transition-colors hover:bg-[#FBF7F2]"
                           >
                              <div className="flex items-start justify-between gap-4">
                                 <div>
                                    <p className="text-[0.68rem] uppercase tracking-[0.18em] text-[#7A7570]">
                                       #{cotizacion.id}
                                    </p>
                                    <h2
                                       className="mt-2 text-2xl font-medium text-[#1A1A1A]"
                                       style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
                                    >
                                       {cotizacion.titulo || "N/A"}
                                    </h2>
                                 </div>
                                 <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium ${estadoConfig.color}`}>
                                    <IconComponent className="h-3.5 w-3.5" />
                                    {estadoConfig.label}
                                 </span>
                              </div>

                              <p className="mt-3 text-sm text-[#7A7570]">
                                 {formatDate(cotizacion.created_at)}
                              </p>

                              {cotizacion.detalle ? (
                                 <p className="mt-3 text-sm leading-relaxed text-[#7A7570]">
                                    {cotizacion.detalle}
                                 </p>
                              ) : null}

                              <p className="mt-4 text-sm font-medium text-[#9B6D3F]">
                                 {cotizacion.precio > 0
                                    ? `U$S ${Number(cotizacion.precio).toLocaleString()}`
                                    : "Pendiente"}
                              </p>
                           </article>
                        );
                     })}
                  </div>
               </>
            )}

         {/* 👈 Modal only shows when selectedCotizacion is not null */}
         {selectedCotizacion && (
            <CotizacionModal
               cotizacion={selectedCotizacion}
               onClose={cerrarModal}
            />
         )}
      </div>
      </div>

   );
}